module.exports = __webpack_public_path__ + "img/shield.1daef3e2.png";